module.exports = __webpack_public_path__ + "img/image-card-02.0f6bc2ad.png";